import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PopupStyle } from './popup.types';

@Component({
  standalone: false,
  selector: 'ssc-popup',
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupComponent {
  @Input() public isOpen: boolean;
  @Input() public title: string;
  @Input() public popupStyle: PopupStyle = 'standard';
  @Input() public hasHeader: boolean = true;
  @Output() public closed = new EventEmitter();

  public cancelWhenClickOutsidePopup(event: Event): void {
    if ((event.target as HTMLInputElement).hasAttribute('visanaLibFocusTrap')) {
      this.closed.emit();
    }
  }
}
